export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/factory-direct-bg-ed55623e81afadf3a87b375754cbc8e6.png";